class AyumeManifesto extends HTMLElement{
 connectedCallback(){
  if(this.abort)return;this.abort=new AbortController();const {signal}=this.abort;
  this.reduced=matchMedia('(prefers-reduced-motion:reduce)');
  this.text=this.querySelector('p');
  // Text nodes only: keep links and real words intact, never split a word.
  const walker=document.createTreeWalker(this.text,NodeFilter.SHOW_TEXT);const textNodes=[];while(walker.nextNode())textNodes.push(walker.currentNode);
  textNodes.forEach(node=>{const fragment=document.createDocumentFragment();node.textContent.split(/(\s+)/).forEach(word=>{if(!word)return;if(/^\s+$/.test(word))fragment.append(document.createTextNode(word));else{const span=document.createElement('span');span.className='av-manifesto-word';span.textContent=word;fragment.append(span);}});node.replaceWith(fragment);});
  this.words=[...this.querySelectorAll('.av-manifesto-word')];
  const queue=()=>{if(!this.frame&&this.active)this.frame=requestAnimationFrame(()=>this.update());};
  this.observer=new IntersectionObserver(entries=>{this.active=entries[0].isIntersecting;queue();});this.observer.observe(this);
  window.addEventListener('scroll',queue,{passive:true,signal});document.querySelector('.page-wrapper')?.addEventListener('scroll',queue,{passive:true,signal});
  window.addEventListener('resize',()=>{if(this.clientWidth!==this.layoutWidth)this.configure();},{passive:true,signal});
  this.reduced.addEventListener('change',()=>this.configure(),{signal});
  document.fonts.ready.then(()=>this.configure());
 }
 configure(){
  const settings=document.querySelector('.av-header');
  const enabled=!this.reduced.matches&&settings?.dataset.avMotion!=='false';
  // Short landscape windows keep the complete text readable without pinning.
  this.layoutWidth=this.clientWidth;
  this.lastLit=null;
  const available=document.documentElement.clientHeight-(parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--av-header-height'))||72)-80;
  this.classList.toggle('is-scroll-manifesto',enabled&&this.text.offsetHeight<=available);
  this.update();
 }
 update(){
  this.frame=0;
  if(!this.classList.contains('is-scroll-manifesto')){this.words.forEach(word=>word.classList.add('is-lit'));return;}
  const rect=this.getBoundingClientRect();const sticky=this.querySelector('.av-manifesto-sticky');const top=parseFloat(getComputedStyle(sticky).top)||0;
  const progress=Math.max(0,Math.min(1,(top-rect.top)/(this.offsetHeight-sticky.offsetHeight)));
  const lit=Math.round(progress*this.words.length*1.15);
  if(lit===this.lastLit)return;this.lastLit=lit;
  this.words.forEach((word,i)=>word.classList.toggle('is-lit',i<lit));
 }
 disconnectedCallback(){this.abort?.abort();this.abort=null;this.observer?.disconnect();cancelAnimationFrame(this.frame);}
}
if(!customElements.get('ayume-manifesto'))customElements.define('ayume-manifesto',AyumeManifesto);
